import { mapPrefixes, } from '@/utils/challenge/relationship'

const createRegistrationDetails = (prefix) => ([
  {
    label: 'Registration Date',
    type: 'DATE',
    inline: true,
    fieldId: 'RR_INITIAL_REGISTRATION_DATE',
    jsonPath: `$.${prefix}.registration.initialRegistrationDate`,
    text: 'The date at which the relationship information was first collected.',
  },
  {
    label: 'Last Update',
    type: 'DATE',
    inline: true,
    fieldId: 'RR_LAST_UPDATE_DATE',
    jsonPath: `$.${prefix}.registration.lastUpdateDate`,
    text: 'The date at which the information was most recently updated.',
  },
  {
    label: 'Status',
    isStatus: true,
    inline: true,
    type: 'ENUM',
    except: [ 'PENDING_VALIDATION', ],
    fieldId: 'RR_REGISTRATION_STATUS',
    jsonPath: `$.${prefix}.registration.status`,
    text: 'The status of the legal entity\'s relationship record registration.',
  },
  {
    label: 'Next Renewal',
    type: 'DATE',
    inline: true,
    fieldId: 'RR_NEXT_RENEWAL_DATE',
    jsonPath: `$.${prefix}.registration.nextRenewalDate`,
    text: 'The next date by which the relationship information must be renewed and re-certified by the legal entity.',
  },
  {
    label: 'LEI Issuer',
    isLeiIssuer: true,
    type: 'RESOURCE',
    inline: true,
    fieldId: 'RR_MANAGING_LOU',
    jsonPath: `$.${prefix}.registration.managingLou`,
    // disabled: false,
    text: 'The LEI of the LEI Issuer that is responsible for administering this relationship record.',
  },
  {
    label: 'Corroboration Level',
    type: 'ENUM',
    except: [ 'PENDING', ],
    inline: true,
    fieldId: 'RR_VALIDATION_SOURCES',
    jsonPath: `$.${prefix}.registration.corroborationLevel`,
    text: 'Level of relationship corroboration.',
  },
  {
    label: 'Corroborating Documents',
    type: 'ENUM',
    inline: true,
    fieldId: 'RR_VALIDATION_DOCUMENTS',
    jsonPath: `$.${prefix}.registration.corroborationDocuments`,
    text: 'Type of source document(s) used for validating the relationship.',
  },
  {
    label: 'Reference To Corroborating Documents',
    type: 'STRING',
    inline: true,
    fieldId: 'RR_VALIDATION_REFERENCE',
    jsonPath: `$.${prefix}.registration.corroborationReference`,
    text: 'A reference to a specfic document or other source used as the basis of relationship validation for this relationship record.',
  },
])

export default mapPrefixes(createRegistrationDetails)



// WEBPACK FOOTER //
// ./src/utils/challenge/relationship-registration-details.js